require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

module.exports = function (num) {
  if (!isNaN(num)) {
    return num.toString(10) + 'px';
  }

  return num;
};